/* Science library - behaviour for sections/science-library.liquid.
   Product, benefit and ingredient filters (instant, kept in the URL:
   ?product=&benefit=&ingredient=), "Show N more studies", #study-<handle>
   deep links, the Key Benefits carousel (Figma 36516:80199 / 36598:11343),
   and the page's motion: scroll reveals and the hero photo's parallax. */
(function () {
  'use strict';

  var SIZES = { active: 260, near: 233, far: 215, rest: 240 };

  var MOTION = !(window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches) &&
    'IntersectionObserver' in window;
  var REVEAL = '.sci-selector__label, .sci-option, .sci-chip--essential, .sci-benefits__intro, .sci-carousel, ' +
    '.sci-filter__heading, .sci-filter__controls, .sci-pinned, .sci-group__heading, .sci-study, .sci-group__more, ' +
    '.sci-context > *';

  /* Elements rise in as they enter the viewport. Each batch that arrives
     together staggers by 70ms; hidden ones (other panels, collapsed cards)
     wait until they are shown and scrolled to. */
  function initReveal(root) {
    if (!MOTION) return;
    document.documentElement.classList.add('sci-motion');
    var io = new IntersectionObserver(function (entries) {
      var k = 0;
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        var el = en.target;
        el.style.setProperty('--sci-delay', Math.min(k++, 8) * 0.07 + 's');
        el.classList.add('is-in');
        io.unobserve(el);
        setTimeout(function () { el.style.removeProperty('--sci-delay'); }, 1400);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
    root.querySelectorAll(REVEAL).forEach(function (el) {
      el.setAttribute('data-sci-reveal', '');
      io.observe(el);
    });
  }

  /* The hero photo drifts at a fraction of the scroll speed. */
  function initParallax() {
    var media = document.querySelector('.sci-hero__media');
    if (!MOTION || !media || media.__sci) return;
    media.__sci = true;
    var panel = media.parentNode;
    var ticking = false;
    function update() {
      ticking = false;
      var r = panel.getBoundingClientRect();
      if (r.bottom < 0 || r.top > innerHeight) return;
      var y = Math.max(-60, Math.min(60, -r.top * 0.18));
      media.style.setProperty('--sci-parallax', y.toFixed(1) + 'px');
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; requestAnimationFrame(update); }
    }, { passive: true });
    update();
  }

  function esc(v) { return window.CSS && CSS.escape ? CSS.escape(String(v)) : String(v).replace(/["\\\]]/g, '\\$&'); }

  function initCarousel(el, start) {
    if (!el || el.__sci) return el && el.__sci;
    var viewport = el.querySelector('[data-sci-viewport]');
    var track = el.querySelector('[data-sci-track]');
    var originals = Array.prototype.slice.call(el.querySelectorAll('[data-sci-slide]'));
    var count = originals.length;
    if (!count) return null;
    /* Short lists repeat (whole sets, so the order holds) until the row has
       at least MIN_SLOTS cards and both sides of the middle card stay full. */
    var MIN_SLOTS = 12;
    var copies = Math.ceil(MIN_SLOTS / count);
    for (var c = 1; c < copies; c++) {
      originals.forEach(function (o) {
        var clone = o.cloneNode(true);
        clone.setAttribute('data-sci-clone', '');
        track.appendChild(clone);
      });
    }
    var slides = Array.prototype.slice.call(el.querySelectorAll('[data-sci-slide]'));
    var dots = Array.prototype.slice.call(el.querySelectorAll('[data-sci-dot]'));
    var prev = el.querySelector('[data-sci-prev]');
    var next = el.querySelector('[data-sci-next]');
    var n = slides.length;
    var index = ((start % count) + count) % count;
    var lastD = [];

    function state(d) {
      var a = Math.abs(d);
      return a === 0 ? 'active' : a === 1 ? 'near' : a === 2 ? 'far' : 'rest';
    }

    /* Loops: each card sits at its shortest distance round the circle from the
       middle card, so the first cards come back round after the last. */
    function offset(i) {
      var d = ((i - index) % n + n) % n;
      return d > n / 2 ? d - n : d;
    }

    function layout(step) {
      var w = viewport.clientWidth;
      if (!w) return;
      var wide = w >= 700;
      var gap = wide ? 33 : 16;
      var restGap = wide ? 18 : 16;
      var spacing = function (d) { return Math.abs(d) <= 2 ? gap : restGap; };
      var byD = {};
      byD[0] = w / 2 - SIZES.active / 2;
      var maxD = Math.floor(n / 2);
      for (var d = 1; d <= maxD; d++) byD[d] = byD[d - 1] + SIZES[state(d - 1)] + spacing(d - 1);
      for (var e = -1; e >= -maxD; e--) byD[e] = byD[e + 1] - SIZES[state(e)] - spacing(e + 1);
      slides.forEach(function (s, i) {
        var d = offset(i);
        var st = state(d);
        /* a card that wraps from one end to the other jumps instead of
           sliding across the middle; it is faded out under the fog anyway */
        var wrapped = typeof step === 'number' && lastD[i] !== undefined && d !== lastD[i] - step;
        if (wrapped) s.style.transition = 'none';
        s.classList.toggle('is-active', st === 'active');
        s.classList.toggle('is-near', st === 'near');
        s.classList.toggle('is-far', st === 'far');
        s.style.left = byD[d] + 'px';
        if (wrapped) {
          void s.offsetWidth;
          s.style.transition = '';
        }
        lastD[i] = d;
        s.setAttribute('aria-hidden', st === 'active' && !s.hasAttribute('data-sci-clone') ? 'false' : 'true');
        s.setAttribute('aria-label', (i % count + 1) + ' / ' + count);
      });
      dots.forEach(function (dot, i) { dot.setAttribute('aria-current', i === index % count ? 'true' : 'false'); });
    }

    function go(i) {
      var target = ((i % n) + n) % n;
      var step = ((target - index) % n + n) % n;
      if (step > n / 2) step -= n;
      index = target;
      layout(step);
    }

    if (prev) prev.addEventListener('click', function () { go(index - 1); });
    if (next) next.addEventListener('click', function () { go(index + 1); });
    /* a dot means a callout, not a slot: go to the nearest copy of it */
    function goLogical(k) {
      var best = null;
      for (var j = k; j < n; j += count) {
        var st = ((j - index) % n + n) % n;
        if (st > n / 2) st -= n;
        if (best === null || Math.abs(st) < Math.abs(best)) best = st;
      }
      go(index + best);
    }
    dots.forEach(function (d, i) { d.addEventListener('click', function () { goLogical(i); }); });
    slides.forEach(function (s, i) { s.addEventListener('click', function () { if (i !== index) go(i); }); });
    viewport.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(index - 1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); go(index + 1); }
    });

    var x0 = null;
    viewport.addEventListener('pointerdown', function (e) { x0 = e.clientX; });
    viewport.addEventListener('pointerup', function (e) {
      if (x0 === null) return;
      var dx = e.clientX - x0;
      x0 = null;
      if (Math.abs(dx) > 40) go(index + (dx < 0 ? 1 : -1));
    });
    viewport.addEventListener('pointercancel', function () { x0 = null; });

    el.__sci = { layout: layout, go: go };
    layout();
    return el.__sci;
  }

  function init(root) {
    if (!root || root.__sci) return;
    root.__sci = true;
    var handles = (root.dataset.sciProducts || '').split(',').filter(Boolean);
    var before = parseInt(root.dataset.cardsBefore, 10) || 2;
    var start = (parseInt(root.dataset.carouselStart, 10) || 1) - 1;
    var L = {
      all: root.dataset.labelAllBenefits || 'All benefits',
      studies: root.dataset.labelStudies || 'studies',
      study: root.dataset.labelStudy || 'study',
      more: root.dataset.labelMore || 'Show [count] more studies',
      moreOne: root.dataset.labelMoreOne || 'Show 1 more study',
      fewer: root.dataset.labelFewer || 'Show fewer studies'
    };
    var state = {};

    function panelFor(h) { return root.querySelector('[data-sci-panel="' + esc(h) + '"]'); }

    function panelState(h) {
      if (!state[h]) state[h] = { benefit: 'all', ingredient: 'all', open: {} };
      return state[h];
    }

    function writeUrl() {
      var h = root.dataset.activeProduct;
      var s = panelState(h);
      var url = new URL(location.href);
      url.searchParams.set('product', h);
      if (s.benefit !== 'all') url.searchParams.set('benefit', s.benefit); else url.searchParams.delete('benefit');
      if (s.ingredient !== 'all') url.searchParams.set('ingredient', s.ingredient); else url.searchParams.delete('ingredient');
      history.replaceState(history.state, '', url.pathname + url.search + url.hash);
    }

    function refresh(h) {
      var groups = panelFor(h) && panelFor(h).querySelector('.sci-groups');
      if (!groups || !MOTION) return;
      groups.classList.remove('is-refresh');
      void groups.offsetWidth;
      groups.classList.add('is-refresh');
    }

    function apply(h) {
      var panel = panelFor(h);
      if (!panel) return;
      var s = panelState(h);
      var benefitChip = panel.querySelector('[data-sci-benefit="' + esc(s.benefit) + '"]');
      if (!benefitChip) { s.benefit = 'all'; benefitChip = panel.querySelector('[data-sci-benefit="all"]'); }
      panel.querySelectorAll('[data-sci-benefit]').forEach(function (b) {
        b.setAttribute('aria-pressed', b === benefitChip ? 'true' : 'false');
      });

      var select = panel.querySelector('[data-sci-ingredient]');
      if (select) {
        if (!select.querySelector('option[value="' + esc(s.ingredient) + '"]')) s.ingredient = 'all';
        select.value = s.ingredient;
      } else {
        s.ingredient = 'all';
      }

      var matchesBenefit = function (c) { return s.benefit === 'all' || c.dataset.benefit === s.benefit; };
      var total = 0;
      var firstVisible = null;
      var groupHasBenefit = {};
      panel.querySelectorAll('[data-sci-group]').forEach(function (group) {
        var slug = group.dataset.sciGroup;
        var cards = Array.prototype.slice.call(group.querySelectorAll('[data-sci-card]'));
        var byBenefit = cards.filter(matchesBenefit);
        groupHasBenefit[slug] = byBenefit.length;
        var match = s.ingredient === 'all' || s.ingredient === slug ? byBenefit : [];
        var open = !!s.open[slug];
        cards.forEach(function (c) { c.hidden = true; });
        match.forEach(function (c, i) { c.hidden = !open && i >= before; });
        group.hidden = match.length === 0;
        if (!group.hidden && !firstVisible) firstVisible = group;
        group.classList.remove('is-first-visible');
        var more = group.querySelector('[data-sci-more]');
        var extra = match.length - before;
        if (more) {
          more.hidden = extra < 1;
          more.setAttribute('aria-expanded', open ? 'true' : 'false');
          more.textContent = open ? L.fewer : extra === 1 ? L.moreOne : L.more.replace('[count]', extra);
        }
        total += match.length;
      });
      if (firstVisible) firstVisible.classList.add('is-first-visible');

      if (select) {
        Array.prototype.forEach.call(select.options, function (o) {
          if (o.value !== 'all') o.disabled = !groupHasBenefit[o.value];
        });
      }

      var pinned = panel.querySelectorAll('[data-sci-pinned]').length;
      var count = s.benefit === 'all' && s.ingredient === 'all' ? total + pinned : total;
      var parts = [s.benefit === 'all' ? L.all : benefitChip.dataset.label];
      if (s.ingredient !== 'all' && select) parts.push(select.options[select.selectedIndex].text);
      parts.push(count + ' ' + (count === 1 ? L.study : L.studies));
      var summary = panel.querySelector('[data-sci-summary]');
      if (summary) summary.textContent = parts.join(' · ');
      var empty = panel.querySelector('[data-sci-empty]');
      if (empty) empty.hidden = total > 0 || pinned > 0;
    }

    function showProduct(h, opts) {
      opts = opts || {};
      if (handles.indexOf(h) < 0) h = handles[0];
      root.dataset.activeProduct = h;
      root.querySelectorAll('[data-sci-option]').forEach(function (b) {
        b.setAttribute('aria-pressed', b.dataset.sciOption === h ? 'true' : 'false');
      });
      if (opts.reset) state[h] = null;
      apply(h);
      var panel = panelFor(h);
      var carousel = panel && initCarousel(panel.querySelector('[data-sci-carousel]'), start);
      if (carousel) carousel.layout();
      if (opts.url !== false) writeUrl();
    }

    root.addEventListener('click', function (e) {
      var option = e.target.closest('[data-sci-option]');
      if (option) {
        if (option.dataset.sciOption !== root.dataset.activeProduct) showProduct(option.dataset.sciOption, { reset: true });
        return;
      }
      var chip = e.target.closest('[data-sci-benefit]');
      if (chip) {
        var s = panelState(root.dataset.activeProduct);
        s.benefit = chip.dataset.sciBenefit;
        s.open = {};
        apply(root.dataset.activeProduct);
        refresh(root.dataset.activeProduct);
        writeUrl();
        return;
      }
      var more = e.target.closest('[data-sci-more]');
      if (more) {
        var group = more.closest('[data-sci-group]');
        var st = panelState(root.dataset.activeProduct);
        st.open[group.dataset.sciGroup] = !st.open[group.dataset.sciGroup];
        apply(root.dataset.activeProduct);
        if (!st.open[group.dataset.sciGroup]) group.scrollIntoView({ block: 'nearest' });
      }
    });

    root.addEventListener('change', function (e) {
      if (!e.target.matches('[data-sci-ingredient]')) return;
      var s = panelState(root.dataset.activeProduct);
      s.ingredient = e.target.value;
      s.open = {};
      apply(root.dataset.activeProduct);
      refresh(root.dataset.activeProduct);
      writeUrl();
    });

    function openStudy(handle) {
      var h = root.dataset.activeProduct;
      var sel = '[data-sci-study="' + esc(handle) + '"]';
      var card = panelFor(h) && panelFor(h).querySelector(sel);
      if (!card) {
        for (var i = 0; i < handles.length && !card; i++) {
          card = panelFor(handles[i]).querySelector(sel);
          if (card) { h = handles[i]; showProduct(h, { reset: true }); }
        }
      }
      if (!card) return;
      var group = card.closest('[data-sci-group]');
      var s = panelState(h);
      if (group && card.hidden) {
        if (!(s.benefit === 'all' || card.dataset.benefit === s.benefit) ||
            !(s.ingredient === 'all' || s.ingredient === group.dataset.sciGroup)) {
          s.benefit = 'all';
          s.ingredient = 'all';
        }
        s.open[group.dataset.sciGroup] = true;
        apply(h);
        writeUrl();
      }
      card.scrollIntoView({ behavior: 'smooth', block: 'start' });
      card.classList.add('is-flash');
      setTimeout(function () { card.classList.remove('is-flash'); }, 1700);
    }

    var params = new URLSearchParams(location.search);
    var initial = root.dataset.activeProduct;
    var s0 = panelState(initial);
    if (params.get('benefit')) s0.benefit = params.get('benefit');
    if (params.get('ingredient')) s0.ingredient = params.get('ingredient');
    showProduct(initial, { url: params.has('product') || params.has('benefit') || params.has('ingredient') });

    function fromHash() {
      var m = /^#study-(.+)$/.exec(location.hash);
      if (m) { try { openStudy(decodeURIComponent(m[1])); } catch (e) { /* malformed link: ignore */ } }
    }
    initReveal(root);
    initParallax();
    fromHash();
    window.addEventListener('hashchange', fromHash);

    var raf;
    window.addEventListener('resize', function () {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () {
        var p = panelFor(root.dataset.activeProduct);
        var c = p && p.querySelector('[data-sci-carousel]');
        if (c && c.__sci) c.__sci.layout();
      });
    });
  }

  function boot() { document.querySelectorAll('[data-sci]').forEach(init); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-sci]');
    if (root) init(root);
  });
})();
